import axios from 'axios'
import store from '@/store'
import { User } from '../kne/user'
import AuthInfo from '../kne/authToken'
import { IUser, INewUserRequest, IUserDeleteRequest } from '../model/UserState'

export default class UserService {
  login (name: string, password: string): Promise<AuthInfo> {
    return new Promise((resolve, reject) => {
      const loginData = {
        userName: name,
        userpassword: password
      };
      const loginHeaders = {
        headers: {
          "Content-Type": "application/json"
        }
      };
      axios.post("/api/auth/login", loginData, loginHeaders).then(res => {
        resolve(res.data)
      })
    })
  }

  logout (): Promise<any> {
    return new Promise((resolve) => {
      resolve("")
    })
  }
  
  getAllUsers (): Promise<IUser[]> {
    return new Promise((resolve, reject) => {
      axios.get('/api/admin/GetAllUsers').then(res => {
        resolve(res.data)
      }, (err: Error) => {
        console.error(err);
        reject(err)
      })
    })
  }
  
  addNewUser(newUserRequest: INewUserRequest): Promise<IUser> {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/AddNewUser", newUserRequest).then(res => {
        resolve(res.data)
      }, (err: Error) => {
        console.error(err);
        reject(err)
      })
    })
  }

  deleteUser(deleteUserRequest: IUserDeleteRequest): Promise<boolean>{
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/DeleteUser", deleteUserRequest).then(res => {
        resolve(res.data)
      }, (err: Error) => {
        console.error(err);
        reject(err)
      })
    })
  }
}

